export const isGreaterWithTolerance = (num1, num2, tolerance = 0.005) =>
  Number(num1) - Number(num2) > tolerance;
